import * as React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { INamedItemInfo } from '../../../../ts/models/resourceInfoParts';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { ExplorerStyles } from '../../Explorer/ExplorerStyles';
import { EntityLink, EntityLinkProps } from './EntityLink';


export interface RelatedEntityProps {
  label: string;
  link: EntityLinkProps;
}

export const RelatedEntity = (props: RelatedEntityProps) => {
  if (props.link) {
    return (
      <div className={DetailsTooltipStyles.MetadataSection} style={{display: 'flex', flexDirection: 'row', minWidth: 0}}>
        <div className={DetailsTooltipStyles.MetadataRelatedTitle} style={{flexGrow: 0}}>{ props.label }</div>
        <EntityLink {...props.link} />
      </div>
    );
  } else {
    return null;
  }
};
